import Data from '@/public/data/Spagetti.json'
import styles from '@/styles/About.module.css'
import Image from 'next/image'
import HomeImage from '../public/img/Home.webp'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import withImageErrorHandling from './HOC/withImageErrorHandling'

const Pasta = () => {
  const grayscaleStyle = {
    filter: 'grayscale(100%)', // Apply grayscale filter
  }
  const [loading, setLoading] = useState(true)
  const [imageError, setImageError] = useState(false) // State for image error
  const { t, i18n } = useTranslation()

  const handleImageLoad = () => {
    setLoading(false)
  }

  const handleImageError = () => {
    setLoading(false) // Set loading to false when image fails to load
    setImageError(true) // Set imageError to true when image fails to load
  }

  return (
    <section className={styles.cardContainer}>
      <div className={styles.card}>
        <header className={styles.cardHeader}>
          <h2>{t('PASTA DISHES')}</h2>
          <span className={styles.additional}>
            {t(
              `We don't know your allergy? Ask us about what the food contains.`
            )}
          </span>
        </header>
        <main className={styles.cardsContainer}>
          {Data &&
            Data.map((data, id) => {
              return (
                <ol role='list' className={styles.cardItem} key={id}>
                  <li className={styles.imageContainer}>
                    {loading && <div className={styles.loadingSkeleton}></div>}
                    <div className={styles.imageWrapper}>
                      <Image
                        src={data.imageUrl || HomeImage}
                        className={styles.imageUrl}
                        width={200}
                        height={100}
                        alt={data.alt}
                        aria-label={data.alt || t('Image Not Available')}
                        loading='lazy'
                        layout='responsive'
                        // priority
                        style={data.imageUrl ? {} : grayscaleStyle}
                        onError={handleImageError}
                        onLoad={handleImageLoad}
                        // Call handleImageLoad when image is loaded
                        // as='img'
                      />
                      {!data.imageUrl && !loading && (
                        <span
                          className={styles.comingSoon}
                          aria-label='Image Not Available'
                        >
                          {t('Image Not Available')}
                        </span>
                      )}
                    </div>
                  </li>
                  <figcaption className={styles.figCaption}>
                    {data.Name}
                    {data.Regular ? <span>{data.Regular}kr</span> : null}
                  </figcaption>
                  <div className={styles.cardItemWrapper}>
                    {data.Ingredients ? (
                      <span className={styles.cardSpanIng}>
                        {t(data.Ingred)}
                      </span>
                    ) : null}
                  </div>
                </ol>
              )
            })}
        </main>
      </div>
    </section>
  )
}

export default Pasta
